module.exports = __webpack_public_path__ + "img/goodsD2.36096cb4.png";